import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Button } from "../components/ui/button";
import { NETWORK_STEPS, RANK_STAGES, NETWORK_COMPLIANCE } from "../lib/data";

const Icon = ({ name, className }) => { const C = Icons[name] || Icons.Circle; return <C className={className} />; };
const fadeUp = { hidden: { opacity: 0, y: 24 }, show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.45, delay: i * 0.05 } }) };

export default function Opportunity() {
  return (
    <div data-testid="opportunity-page" className="bg-cream-100 text-soil-700 pt-24 pb-24">
      <section className="max-w-7xl mx-auto px-4 sm:px-6 pt-8 pb-12">
        <div className="relative rounded-3xl overflow-hidden forest-gradient text-cream-50 p-8 sm:p-14 text-center">
          <div className="absolute inset-0 bharat-pattern opacity-40" />
          <div className="relative">
            <div className="inline-block text-xs uppercase tracking-[0.22em] font-bold text-saffron-500 mb-3">Genesis Business Network</div>
            <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">Genesis <span className="text-saffron-500">Business Network</span></h1>
            <p className="mt-4 text-lg text-cream-100 max-w-2xl mx-auto">Refer, build a team, progress through ranks and unlock rewards — a transparent, compliant opportunity within the Genesis ecosystem.</p>
            <div className="flex flex-wrap justify-center gap-3 mt-8">
              <Link to="/register" data-testid="opportunity-register-cta"><Button className="terracotta-gradient text-cream-50 font-bold h-12 px-7 rounded-full text-base">Join Genesis Network</Button></Link>
              <Link to="/ranks-rewards" data-testid="opportunity-ranks-cta"><Button className="bg-cream-50 text-forest-800 hover:bg-cream-200 font-bold h-12 px-6 rounded-full">Ranks &amp; Rewards</Button></Link>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 pb-6">
        <div className="text-center"><div className="text-xs uppercase tracking-[0.2em] font-bold text-terracotta-600 mb-3">How the Network Works</div><h2 className="font-heading text-2xl sm:text-3xl font-bold text-forest-800">Six Simple Steps</h2></div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
          {NETWORK_STEPS.map((s, i) => (
            <motion.div key={s.t} custom={i} initial="hidden" whileInView="show" viewport={{ once: true }} variants={fadeUp} className="card-cream rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-xl forest-gradient flex items-center justify-center"><Icon name={s.icon} className="w-5 h-5 text-cream-50" /></div>
                <span className="font-mono-fin text-terracotta-500 font-bold">{String(i + 1).padStart(2, "0")}</span>
              </div>
              <div className="font-heading text-lg font-bold text-forest-800">{s.t}</div>
              <div className="text-soil-500 text-sm mt-1">{s.d}</div>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {RANK_STAGES.map((st, i) => (
            <div key={st.k} className="card-cream rounded-2xl p-5 text-center">
              <div className="w-10 h-10 mx-auto rounded-full terracotta-gradient flex items-center justify-center font-mono-fin font-bold text-cream-50 mb-3">{i + 1}</div>
              <div className="font-heading text-lg font-extrabold text-terracotta-600">{st.k}</div>
              <div className="text-soil-500 text-xs mt-1">{st.d}</div>
            </div>
          ))}
        </div>
        <p className="text-soil-500 text-xs mt-8 max-w-3xl mx-auto text-center" data-testid="opportunity-compliance">{NETWORK_COMPLIANCE}</p>
      </section>
    </div>
  );
}
